import React, { Component } from 'react';
import { Image, ThumbnailsWrapper } from './ImatgesElement';

export default class Imatges extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <ThumbnailsWrapper>
        {this.props.fotos.map((foto, i) => {
          return <Image onClick={() => this.props.toggleGaleria(true, i)} altura={this.props.alturaInfoPunt + 'px'} src={`${foto}`} alt="Imatge" />;
        })}
      </ThumbnailsWrapper>
    );
  }
}
